import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const FundWallerValidationSchema = yup.object({
  walletId: yup.string().required("Wallet is required"),
  store: yup.string().required("Store is required"),
  amount: yup.string().required("Amount is required"),
  note: yup.string(),
});

export const Validation = ({ debitDetails }) => {
  return useForm({
    resolver: yupResolver(FundWallerValidationSchema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      walletId: debitDetails?.wallet_id,
      store: debitDetails?.store_id,
      amount: debitDetails?.amount,
      note: debitDetails?.description,
    },
  });
};
